module.exports = __webpack_public_path__ + "static/media/consumer-affairs-hero.ae6f729a.jpg";